import { render, staticRenderFns } from "./DialogoCriarChamado.vue?vue&type=template&id=d599d7ba"
import script from "./DialogoCriarChamado.vue?vue&type=script&lang=js"
export * from "./DialogoCriarChamado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports